import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { formatRTKQueryBaseQueryError } from './formatRTKQueryBaseQueryError';
import { formatRTKQuerySerializedError } from './formatRTKQuerySerializedError';

export function formatRTKQueryError(
  error: FetchBaseQueryError | SerializedError
) {
  if ('status' in error) {
    return formatRTKQueryBaseQueryError(error);
  }

  return formatRTKQuerySerializedError(error);
}

export function isRTKQueryError(
  error: any
): error is FetchBaseQueryError | SerializedError {
  return (
    error &&
    typeof error === 'object' &&
    ('status' in error || 'message' in error)
  );
}
